//@ts-ignore
const files = require.context(
    "../assets/avatarPack", // context folder
    true, // include subdirectories
    /.*\.svg/ // RegExp
);

//console.log(files.keys().forEach((it:any)=>console.log(it, files(it))));

export const womans = {
    "./100.svg": "./100.svg",
    "./102.svg": "./102.svg",
    "./103.svg": "./103.svg",
    "./104.svg": "./104.svg",
    "./11.svg": "./11.svg",
    "./110.svg": "./110.svg",
    "./12.svg": "./12.svg",
    "./13.svg": "./13.svg",
    "./14.svg": "./14.svg",
    "./16.svg": "./16.svg",
    "./17.svg": "./17.svg",
    "./18.svg": "./18.svg",
    "./20.svg": "./20.svg",
    "./23.svg": "./23.svg",
    "./26.svg": "./26.svg",
    "./27.svg": "./27.svg",
    "./30.svg": "./30.svg",
    "./33.svg": "./33.svg",
    "./39.svg": "./39.svg",
    "./44.svg": "./44.svg",
    "./53.svg": "./53.svg",
    "./54.svg": "./54.svg",
    "./55.svg": "./55.svg",
    "./61.svg": "./61.svg",
    "./62.svg": "./62.svg",
    "./63.svg": "./63.svg",
    "./66.svg": "./66.svg",
    "./65.svg": "./65.svg",
    "./67.svg": "./67.svg",
    "./68.svg": "./68.svg",
    "./72.svg": "./72.svg",
    "./71.svg": "./71.svg",
    "./73.svg": "./73.svg",
    "./76.svg": "./76.svg",
    "./78.svg": "./78.svg",
    "./80.svg": "./80.svg",
    "./85.svg": "./85.svg",
    "./87.svg": "./87.svg",
    "./91.svg": "./91.svg",
    "./92.svg": "./92.svg",
    "./94.svg": "./94.svg",
    "./97.svg": "./97.svg",
    "./98.svg": "./98.svg",
    "./99.svg": "./99.svg",
    "./70.svg": "./70.svg",
    "./19.svg": "./19.svg"
}

export const getAvatarList =()=>{
    const list: string[] = [];
    files.keys().forEach((it:string)=>{
        list.push(it);
    });
    return list;
};

export const getAvatarGenderList =(gender: 'male' | 'female' | '')=>{
    const list: string[] = [];
    files.keys().forEach((it:string)=>{
        if ((gender == 'male' && !womans[it as keyof typeof womans]) || (gender == 'female' && womans[it as keyof typeof womans]) || (gender == '')){
            list.push(it);
        }
    });
    return list;
};

export const getAvatarByKey = (key:string) => {
    return files(key);
}

export const getAvatarById = (id:string) => {
    return files('./'+id+'.svg');
}

export const getAvatarByNameHash = (name: string) => {
    const avatars = getAvatarList();
    const hash = name
        .split('')
        .reduce((ac, it) => ((it.charCodeAt(0) + ac) % avatars.length), 0);
    const key = avatars[hash];
    return getAvatarByKey(key);
}